<template>
	<div style="max-width: 768px; margin: 0 auto;">
		<v-layout align-center justify-center class="count-layout pa-8" wrap>
			<v-flex xs12>
				<div class="white--text" style="font-size: 24px;">
					{{ reservedayData.title }}
				</div>
			</v-flex>
			<v-flex xs6 class="pr-2">
				<div class="countCard">
					<v-icon dark x-large class="mb-2">mdi-clock-outline</v-icon>
					<div class="year white--text">
						{{ $moment().format('YYYY.MM.DD') }}
					</div>
					<div class="time white--text">
						{{ $moment().format('HH:mm') }}
					</div>
				</div>
			</v-flex>
			<v-flex xs3 class="pl-2">
				<div class="countCard-2">
					<v-icon color="#006a85" class="mb-2" large>mdi-account-circle</v-icon>
					<v-layout align-end justify-center>
						<div class="count">{{ totalCount }}</div>
						<span class="sub ml-1">인</span>
					</v-layout>
				</div>
			</v-flex>
			<v-flex xs3 class="pl-2">
				<div class="countCard-2">
					<v-icon color="#006a85" class="mb-2" large>mdi-account-group</v-icon>
					<v-layout align-end justify-center>
						<div class="count">{{ totalTeamCount }}</div>
						<span class="sub ml-1">팀</span>
					</v-layout>
				</div>
			</v-flex>
		</v-layout>
		<v-layout wrap class="px-8 pt-4 pb-2">
			<v-flex xs12>
				<v-btn @click="teamSetting()" color="#009EA1" dark block class="team-btn" elevation="0">
					<div style="font-size: 20px; font-weight: bold;">팀 + 1</div>
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout wrap class="px-8 pt-4">
			<v-flex xs4 v-for="count in countList" :key="count" :class="count === 4 || count === -1 ? 'pb-4' : 'pb-4 pr-2'">
				<div class="text-center">
					<v-btn
						@click="countSetting(count)"
						class="count-btn"
						elevation="0"
						:color="count === 3 || count === 2 ? '#009EA1' : '#006a85'"
						dark
						width="100%"
					>
						{{ count }}
					</v-btn>
					<div class="btn-border"></div>
				</div>
			</v-flex>
		</v-layout>
		<v-layout wrap class="px-8">
			<v-flex xs4 class="pb-4 pr-2">
				<div class="text-center">
					<v-btn @click="cancel()" class="count-btn-cancel" elevation="0" :color="'#006a85'" dark width="100%">
						<v-icon x-large>mdi-arrow-left-thin</v-icon>
						<div>
							이전 취소
						</div>
					</v-btn>
					<div class="btn-border"></div>
				</div>
			</v-flex>
			<v-flex xs8 class="pb-4">
				<div class="text-center">
					<v-btn @click="countSetting(1)" class="count-btn-plus1" elevation="0" :color="'#FD890F'" dark width="100%">
						<div>
							+ 1
						</div>
					</v-btn>
					<div class="btn-border-plus1"></div>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
export default {
	data() {
		return {
			countList: [6, 5, 4, 3, 2, -1],
			countNumber: 0,
			teamNumber: 0,
			reservedayData: { title: '' },
			countData: {},
		}
	},
	created() {
		this.reserveday()
	},
	computed: {
		totalCount() {
			return String(this.countNumber).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
		},
		totalTeamCount() {
			return String(this.teamNumber).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
		},
	},
	methods: {
		cancel() {
			if (this.countData.id) {
				if (this.countData.counts.length > 0) {
					this.$store.state.loading = true
					const counts = this.countData.counts
					counts.splice(this.countData.counts.length - 1, 1)
					this.$store
						.dispatch('updateCount', {
							id: this.countData.id,
							counts: counts,
						})
						.then(() => {
							this.counts()
						})
				}
			}
		},
		teamSetting() {
			this.$store.state.loading = true
			this.$store
				.dispatch('counts', {
					date: this.$moment().format('YYYY-MM-DD'),
					reserveday: this.$route.params.reserveday,
					business: this.$route.params.business,
				})
				.then(res => {
					if (res.data.counts.length === 0) {
						const counts = [{ time: this.$moment().format('HH:mm:ss'), team: 1 }]
						this.$store
							.dispatch('createCount', {
								date: this.$moment().format('YYYY-MM-DD'),
								counts: counts,
								reserveday: this.$route.params.reserveday,
								business: this.$route.params.business,
							})
							.then(() => {
								this.counts()
							})
					} else {
						const counts = res.data.counts[0].counts
						counts.push({ time: this.$moment().format('HH:mm:ss'), team: 1 })
						this.$store
							.dispatch('updateCount', {
								id: res.data.counts[0].id,
								counts: counts,
							})
							.then(() => {
								this.counts()
							})
					}
				})
		},
		countSetting(count) {
			this.$store.state.loading = true
			this.$store
				.dispatch('counts', {
					date: this.$moment().format('YYYY-MM-DD'),
					reserveday: this.$route.params.reserveday,
					business: this.$route.params.business,
				})
				.then(res => {
					this.countData = res.data.counts[0]
					if (res.data.counts.length === 0) this.createCount(count)
					else this.updateCount(res.data.counts[0].id, count)
				})
		},
		reserveday() {
			this.$store.state.loading = true
			this.$store.dispatch('reservedays', { code: this.$route.params.reserveday }).then(res => {
				if (res.data.reservedays.length > 0) {
					this.reservedayData = res.data.reservedays[0]
					this.counts()
				} else {
					this.$store.state.loading = false
					if (!window.alert('존재하지 않는 사업지 입니다.')) {
						window.open('', '_self').close()
					}
				}
			})
		},
		counts() {
			this.$store
				.dispatch('counts', {
					date: this.$moment().format('YYYY-MM-DD'),
					reserveday: this.$route.params.reserveday,
					business: this.$route.params.business,
				})
				.then(res => {
					this.$store.state.loading = false
					this.countNumber = 0
					this.teamNumber = 0
					if (res.data.counts.length > 0) {
						this.countData = res.data.counts[0]
						for (let index = 0; index < res.data.counts[0].counts.length; index++) {
							const el = res.data.counts[0].counts[index]
							if (el.team) {
								this.teamNumber += 1
							} else {
								this.countNumber += el.count
							}
						}
					}
				})
		},
		createCount(count) {
			const counts = [{ time: this.$moment().format('HH:mm:ss'), count: count }]
			this.$store
				.dispatch('createCount', {
					date: this.$moment().format('YYYY-MM-DD'),
					counts: counts,
					reserveday: this.$route.params.reserveday,
					business: this.$route.params.business,
				})
				.then(() => {
					this.counts()
				})
		},
		updateCount(id, count) {
			const counts = this.countData.counts
			counts.push({ time: this.$moment().format('HH:mm:ss'), count: count })
			this.$store
				.dispatch('updateCount', {
					id: id,
					counts: counts,
				})
				.then(() => {
					this.counts()
				})
		},
	},
}
</script>
<style lang="scss">
.btn-border {
	margin: 0 auto;
	border: 3px solid #315c7c;
	width: 100% !important;
	max-width: 200px !important;
}
.count-btn-cancel {
	font-size: 1.4em !important;
	height: 150px !important;
	max-width: 200px !important;
	border-radius: 0px !important;
	.v-btn__content {
		display: block !important;
	}
}
.count-btn {
	font-size: 64px !important;
	height: 150px !important;
	width: 100% !important;
	max-width: 200px !important;
	border-radius: 0px !important;
}
.count-btn-plus1 {
	font-size: 64px !important;
	height: 150px !important;
	width: 100% !important;
	max-width: 437px !important;
	border-radius: 0px !important;
}
.btn-border-plus1 {
	margin: 0 auto;
	border: 3px solid #d66e00;
	width: 100% !important;
	max-width: 437px !important;
}
.team-btn {
	height: 60px !important;
	border-radius: 8px !important;
	.v-btn__content {
		display: block !important;
	}
}
.count-layout {
	background-color: #006a85;
}
.countCard {
	height: 172px;
	text-align: center;
	border: 1px solid white;
	padding: 16px;
	.year {
		font-size: 24px;
	}
	.time {
		font-size: 36px;
		font-weight: bold;
	}
}
.countCard-2 {
	height: 172px;
	text-align: center;
	background-color: white;
	color: #006a85;
	padding: 16px;
	.count {
		font-size: 48px;
		font-weight: bold;
	}
	.sub {
		font-size: 36px;
	}
}
</style>
